<template>
    <div>
        <b-form-group label="Question" label-for="question">
            <TipTap
                v-model="editable_content.question"
                :class="{'is-invalid': validating && !editable_content.question}"
                :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'image', 'edit_html']"
                @input="setContent('question', $event)"
            />

            <b-form-invalid-feedback :state="validating && !editable_content.question ? false : null">
                Question is required
            </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Image" label-for="image">
            <b-form-invalid-feedback
                class="mb-2"
                :state="
                    validating &&
                    (!editable_content.image || editable_content.image && !editable_content.image.src) ? false : null
                "
            >
                Image is required
            </b-form-invalid-feedback>

            <div class="row">
                <div
                    :class="{
                        'col-6': editable_content.image && editable_content.image.src,
                        'col-12': !editable_content.image || editable_content.image && !editable_content.image.src
                    }"
                >
                    <div v-show="editable_content.image && editable_content.image.src">
                        <div v-if="editable_content.image && editable_content.image.src" class="node-actions m-2">
                            <b-btn size="sm" variant="primary" class="edit mr-1" @click.prevent="edit">
                                <font-awesome-icon :icon="['far', 'edit']"/>
                            </b-btn>
                            <b-btn size="sm" variant="danger" @click.prevent="removeImage">
                                <font-awesome-icon :icon="['fad', 'trash']"/>
                            </b-btn>
                        </div>
                        <div class="mb-2 position-relative">
                            <div
                                :class="{
                                    'merlin-asset-border': editable_content.image && editable_content.image.src && isMerlinMedia(editable_content.image.src)
                                }"
                            >
                                <span
                                    v-if="editable_content.image && editable_content.image.src && isMerlinMedia(editable_content.image.src)"
                                    class="merlin-asset-warning"
                                >
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                    Merlin Asset
                                </span>
                                <b-img
                                    ref="image"
                                    :src="editable_content.image ? editable_content.image.src : ''"
                                    fluid
                                    @click.prevent="addClue($event)"
                                />
                            </div>

                            <div v-for="(clue, index) in editable_content.clues" :key="index">
                                <b-input-group
                                    @click.prevent="focusClue(clue, index)"
                                    :style="{
                                        color: 'white',
                                        width: editable_content.dot_width+'px',
                                        height: editable_content.dot_height+'px',
                                        position: 'absolute',
                                        top: clue.dot.offsetY+'px',
                                        left: clue.dot.offsetX+'px'
                                    }"
                                >
                                    <div :style="{'text-align': 'center', opacity: '1',}">
                                        <div
                                            :style="{
                                                'background-color': 'lightgrey',
                                                'color': 'black',
                                                'text-align': 'center',
                                                'position': 'absolute',
                                                'top': '0px',
                                                'left': '0px',
                                                'width': '20px',
                                                'z-index': 1
                                            }"
                                        >
                                            {{ index + 1 }}
                                        </div>
                                        <div
                                            :style="{
                                                'background-color': 'white',
                                                height: clue.hot_area_height+'px',
                                                opacity: '0.6',
                                                'text-align': 'center',
                                                'position': 'absolute',
                                                'top': '0px',
                                                'left': '0px',
                                                'width': clue.hot_area_width+'px',
                                                'max-height': clue.hot_area_height+'px',
                                                'max-width': clue.hot_area_width+'px'
                                            }"
                                        >
                                        </div>
                                    </div>
                                </b-input-group>
                            </div>
                        </div>
                        <div class="related-media-id">
                            <span v-if="editable_content.image.related_media_id">
                                <b>Media ID:</b> {{ editable_content.image.related_media_id }}
                            </span>
                            <span v-if="editable_content.image.merlin_id">
                                <b>Merlin ID:</b> {{ editable_content.image.merlin_id }}
                            </span>
                            <span v-if="editable_content.image.description">
                                <b>Description:</b> {{ editable_content.image.description }}
                            </span>
                            <span v-if="editable_content.image.alt">
                                <b>ALT:</b> {{ editable_content.image.alt }}
                            </span>
                            <span v-if="editable_content.image.caption">
                                <b>Caption:</b> {{ editable_content.image.caption }}
                            </span>
                            <span v-if="editable_content.image.credit">
                                <b>Credit:</b> {{ editable_content.image.credit }}
                            </span>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div>
                            <b-dropdown
                                size="sm"
                                variant="outline-primary"
                                dropup
                                right
                            >
                                <template #button-content>
                                    <font-awesome-icon :icon="['fad', 'plus-square']"/>
                                    Select Background Image
                                </template>
                                <b-dropdown-item @click.prevent="addExistingRelatedMedia">
                                    <font-awesome-icon :icon="['fad', 'plus-square']" class="text-primary" fixed-width/>
                                    Add SBP Media Image
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>

                </div>
                <div v-if="editable_content.image && editable_content.image.src" class="col-6">
                    <b-form-group
                        label="Clues"
                    >
                        <div
                            v-for="(clue, index) in editable_content.clues"
                            :key="index"
                            class="mb-2"
                        >
                            <b-card>
                                <b-input-group>
                                    <b-input-group-prepend is-text>
                                        <span
                                            class="merlin-asset-small"
                                            v-if="clue.type != 'text' && isMerlinMedia(clue.url)"
                                            content="Merlin Asset"
                                            v-tippy="{placement: 'top'}"
                                        >
                                            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                                        </span>
                                        {{ index + 1 }}
                                    </b-input-group-prepend>
                                    <b-input-group-prepend v-if="clue.type != 'text'">
                                        <div
                                            :id="`edit-popover-${clue.url}`"
                                            :style="{
                                                height: '50px',
                                                'max-height': '50px'
                                            }"
                                        >
                                            <b-img
                                                ref="clue.url"
                                                :src="clue.url"
                                                :style="{
                                                    'max-height': '100%',
                                                    'max-width': '100%'
                                                }"
                                            />
                                        </div>
                                        <div>
                                            <b-popover
                                                :target="`edit-popover-${clue.url}`"
                                                triggers="hover"
                                                placement="top"
                                                class="mt-2"
                                            >
                                                <div class="node-actions m-2">
                                                    <b-btn
                                                        size="sm"
                                                        variant="primary"
                                                        class="edit mr-1"
                                                       @click.prevent="edit('clue')"
                                                    >
                                                        <font-awesome-icon :icon="['far', 'edit']"/>
                                                    </b-btn>
                                                    <b-btn
                                                        size="sm"
                                                        variant="danger"
                                                       @click.prevent="removeClueImage(index)"
                                                    >
                                                        <font-awesome-icon :icon="['fad', 'trash']"/>
                                                    </b-btn>
                                                </div>
                                            </b-popover>
                                        </div>
                                        <related-media-item-modal
                                            v-model="show_related_media_clue_item_modal"
                                            :item="clue"
                                            @update="updateClue($event, clue)"
                                            @hide="show_related_media_clue_item_modal = false"
                                        />
                                    </b-input-group-prepend>

                                    <b-form-input
                                        :ref="'clue' + index"
                                        v-model="clue.text"
                                        :state="validating && !clue.is_empty && !clue.text ? false : null"
                                        v-focus
                                        v-if="clue.type === 'text'"
                                        @blur="updateClueIsEmpty(clue)"
                                    />
                                    <b-form-input
                                        :ref="'clue' + index"
                                        v-model="clue.url"
                                        :state="validating && !clue.url ? false : null"
                                        v-focus
                                        v-else
                                        :disabled="true"
                                        :style="{
                                            height: '50px',
                                            'max-height': '50px'
                                        }"
                                    />

                                    <b-input-group-append>
                                        <b-dropdown
                                            size="sm"
                                            variant="info"
                                            dropup
                                            right
                                        >
                                            <template #button-content>
                                                <font-awesome-icon :icon="['far', 'image']"/>
                                            </template>
                                            <b-dropdown-item @click.prevent="addSBPImageToClue(index)">
                                                <font-awesome-icon
                                                    :icon="['fad', 'plus-square']"
                                                    class="text-primary"
                                                    fixed-width
                                                />
                                                Add SBP Media Image
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </b-input-group-append>

                                </b-input-group>

                                <div class="row mt-2">
                                    <div class="col">
                                        <b-input-group>
                                            <b-input-group-prepend is-text>
                                                X:
                                            </b-input-group-prepend>
                                            <b-form-input
                                                type="number"
                                                :ref="'clue' + index"
                                                v-model="clue.dot.offsetX"
                                                v-focus
                                            />
                                        </b-input-group>
                                    </div>
                                    <div class="col">
                                        <b-input-group>
                                            <b-input-group-prepend is-text>
                                                Y:
                                            </b-input-group-prepend>
                                            <b-form-input
                                                type="number"
                                                :ref="'clue' + index"
                                                v-model="clue.dot.offsetY"
                                                v-focus
                                            />
                                        </b-input-group>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col">
                                        <b-input-group>
                                            <b-input-group-prepend is-text>
                                                Width
                                            </b-input-group-prepend>
                                            <b-form-input
                                                type="number"
                                                :ref="'clue' + index"
                                                v-model="clue.hot_area_width"
                                                v-focus
                                            />
                                        </b-input-group>
                                    </div>
                                    <div class="col">
                                        <b-input-group>
                                            <b-input-group-prepend is-text>
                                                Height
                                            </b-input-group-prepend>
                                            <b-form-input
                                                type="number"
                                                :ref="'clue' + index"
                                                v-model="clue.hot_area_height"
                                                v-focus
                                            />
                                        </b-input-group>
                                    </div>
                                </div>

                                <div class="ml-1 mt-2 row">
                                    <b-form-checkbox
                                        v-model="clue.is_correct"
                                        class="col-6"
                                        switch
                                    >
                                        Correct
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="clue.is_empty"
                                        class="col-6"
                                        switch
                                    >
                                        Empty
                                    </b-form-checkbox>
                                    <b-button
                                        @click="deleteClue(index)"
                                        class="sm"
                                        :style="{'margin-right': '20px', 'margin-left': 'auto'}"
                                        variant="danger">
                                        <font-awesome-icon :icon="['fad', 'trash']" class="text-white" fixed-width/>
                                    </b-button>
                                </div>

                                <b-form-invalid-feedback
                                    class="mb-2"
                                    :state="validating && clue.type === 'text' && !clue.is_empty && !clue.text ? false : null"
                                >
                                    Text is required
                                </b-form-invalid-feedback>
                            </b-card>
                        </div>
                        <b-alert
                            variant="danger"
                            :show="!editable_content.clues || editable_content.clues && !editable_content.clues.length"
                            class="mb-0"
                        >
                            0 Clues
                        </b-alert>

                        <b-form-invalid-feedback
                            class="mt-2"
                            :state="validating && (!editable_content.clues || editable_content.clues && !editable_content.clues.length) ? false : null"
                        >
                            At least 1 clue is required
                        </b-form-invalid-feedback>

                    </b-form-group>
                </div>
            </div>
        </b-form-group>

        <related-media-item-modal
            v-model="show_related_media_item_modal"
            :item="editable_content.image"
            @update="update"
            @hide="show_related_media_item_modal = false"
        />

        <add-related-media-modal
            v-model="show_add_related_media_modal"
            :type="'image'"
            @link="linkRelatedMediaItem"
            @hide="show_add_related_media_modal = false"
        />
    </div>
</template>

<style lang="scss" scoped>
.related-media-id {
    font-size: 80%;
    bottom: 1rem;
    left: 5px;
    margin-bottom: 1rem;
    background: white;
}
</style>

<script>
import Vue from 'vue'
import {mapState} from 'vuex'

import AddRelatedMediaModal from '@/components/modals/article/related_media/AddRelatedMediaModal'
import RelatedMediaItemModal from '@/components/modals/article/related_media/RelatedMediaItemModal'

Vue.directive('tack', {
    twoWay: true,
    bind(el, binding) {
        el.style.position = 'absolute'
        const s = (binding.arg == 'left' ? 'left' : 'top')
        el.style[s] = binding.value + 'px'
    },
    update(el, binding) {
        el.style.position = 'absolute'
        const s = (binding.arg == 'left' ? 'left' : 'top')
        el.style[s] = binding.value + 'px'
    },
    unbind(el) {
        el.style = null
    }
})

export default {
    data: () => ({
        editable_content: {
            image: {},
            clues: [],
            dot_width: 50,
            dot_height: 60,
        },

        show_add_related_media_modal: false,
        linking_to_clue: false,
        linking_to_clue_index: 0,
        show_related_media_item_modal: false,
        show_related_media_clue_item_modal: false,
    }),
    props: [
        'question'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap'),
        AddRelatedMediaModal,
        RelatedMediaItemModal
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    watch: {
        question: {
            handler(question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
            },
            deep: true,
            immediate: true
        },
        editable_content: {
            handler(editable_content) {
                if (editable_content) {
                    if (
                        this.$refs.image
                    ) {
                        if (
                            (this.$refs.image.height && !editable_content.image.height) ||
                            (this.$refs.image.height && editable_content.image.height && this.$refs.image.height !== editable_content.image.height)
                        ) {
                            editable_content.image.height = this.$refs.image.height
                        }
                        if (
                            (this.$refs.image.width && !editable_content.image.width) ||
                            (this.$refs.image.width && editable_content.image.width && this.$refs.image.width !== editable_content.image.width)
                        ) {
                            editable_content.image.width = this.$refs.image.width
                        }
                    }

                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        }
    },
    methods: {
        edit(type) {
            if (type == 'clue') {
                this.show_related_media_clue_item_modal = true
            } else {
                this.show_related_media_item_modal = true
            }
        },
        addExistingRelatedMedia() {
            this.show_add_related_media_modal = true;
        },
        async removeImage() {
            const result = await this.$swal({
                html: 'Are you sure you want remove the background image? If you proceed, all clues will be lost.',
                showCancelButton: true,
                confirmButtonText: 'Remove Image',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })
            if (result.value) {
                this.$set(this.editable_content, 'image', {})
                this.$set(this.editable_content, 'clues', [])
            }
        },
        removeClueImage(index) {
            this.$swal({
                html: 'Are you sure you want remove the clue image? This will set it back to a blank text clue',
                showCancelButton: true,
                confirmButtonText: 'Remove Clue Image',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    // save the clue coordinates, width, height, is_correct, is_empty, but then set to empty text clue
                    const clueCoords = this.editable_content.clues[index].dot;
                    const clueWidth = this.editable_content.clues[index].hot_area_width;
                    const clueHeight = this.editable_content.clues[index].hot_area_height;
                    const clueIsCorrect = this.editable_content.clues[index].is_correct;
                    const clueIsEmpty = this.editable_content.clues[index].is_empty;

                    this.$set(this.editable_content.clues, index, {})
                    this.$set(this.editable_content.clues[index], 'dot', clueCoords);
                    this.$set(this.editable_content.clues[index], 'hot_area_width', clueWidth);
                    this.$set(this.editable_content.clues[index], 'hot_area_height', clueHeight);
                    this.$set(this.editable_content.clues[index], 'is_correct', clueIsCorrect);
                    this.$set(this.editable_content.clues[index], 'is_empty', clueIsEmpty);
                    this.$set(this.editable_content.clues[index], 'text', '');
                    this.$set(this.editable_content.clues[index], 'type', 'text');
                    this.$set(this.editable_content.clues[index], 'url', '');
                }
            })
        },
        update(media) {
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                this.editable_content.image.merlin_id = !isNaN(merlinId) ? merlinId : null
                this.editable_content.image.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                this.editable_content.image.related_media_id = !isNaN(mediaId) ? mediaId : null
                this.editable_content.image.media_id = !isNaN(mediaId) ? mediaId : null
            }
            this.editable_content.image.type = media.type
            this.editable_content.image.src = media.src
            this.editable_content.image.alt = media.alt
            this.editable_content.image.credit = media.credit
            this.editable_content.image.description = media.description
            this.editable_content.image.caption = media.caption
            this.editable_content.image.name = media.name ? media.name : (media.title ? media.title : '')
        },
        updateClue(media, clue) {
            if (media.merlin_id) {
                let merlinId = parseInt(media.merlin_id)
                clue.merlin_id = !isNaN(merlinId) ? merlinId : null
                clue.media_id = !isNaN(merlinId) ? merlinId : null
            } else if (media.related_media_id) {
                let mediaId = parseInt(media.related_media_id)
                clue.related_media_id = !isNaN(mediaId) ? mediaId : null
                clue.media_id = !isNaN(mediaId) ? mediaId : null
            }
            clue.type = media.type
            clue.src = media.src
            clue.alt = media.alt
            clue.credit = media.credit
            clue.description = media.description
            clue.caption = media.caption
            clue.name = media.name ? media.name : (media.title ? media.title : '')
        },
        linkRelatedMediaItem(item) {
            if (this.linking_to_clue) {
                this.editable_content.clues[this.linking_to_clue_index].type = 'image'
                this.editable_content.clues[this.linking_to_clue_index].title = item.title
                this.editable_content.clues[this.linking_to_clue_index].credit = item.credit
                this.editable_content.clues[this.linking_to_clue_index].description = item.description
                this.editable_content.clues[this.linking_to_clue_index].caption = item.caption
                this.editable_content.clues[this.linking_to_clue_index].url = item.url
                this.editable_content.clues[this.linking_to_clue_index].alt = item.alt
                this.editable_content.clues[this.linking_to_clue_index].related_media_id = item.id
                this.linking_to_clue_index = 0;
                this.linking_to_clue = false;
                this.show_add_related_media_modal = false;
            } else {
                this.editable_content.clues = []

                if (this.editable_content.image) {
                    this.editable_content.image = {type: 'image'}
                }

                if (this.editable_content.image) {
                    this.editable_content.image.src = item.url
                    this.editable_content.image.title = item.title
                    this.editable_content.image.description = item.description
                    this.editable_content.image.caption = item.caption
                    this.editable_content.image.credit = item.credit
                    this.editable_content.image.alt = item.alt
                    this.editable_content.image.related_media_id = item.id
                }

                this.show_add_related_media_modal = false;
            }
        },
        addClue($event) {
            if (!this.editable_content.clues) {
                this.$set(this.editable_content, "clues", [])
            }

            this.editable_content.clues.push({
                dot: {
                    offsetY: $event.offsetY,
                    offsetX: $event.offsetX,
                },
                type: 'text',
                url: '',
                hot_area_width: 50,
                hot_area_height: 50,
                is_correct: true,
                is_empty: false,
            })
        },
        focusClue(clue, index) {
            if (this.$refs['clue' + index]) {
                this.$refs['clue' + index][0].focus()
            }
        },
        deleteClue(index) {
            if (this.editable_content.clues) {
                this.editable_content.clues.splice(index, 1)
            }
        },
        setContent(field, value) {
            this.$set(this.editable_content, field, value)
        },
        addSBPImageToClue(index) {
            if (this.editable_content.clues[index]) {
                this.linking_to_clue_index = index;
                this.linking_to_clue = true;
                this.show_add_related_media_modal = true;
            }
        },
        updateClueIsEmpty(clue) {
            if (clue.is_empty && (clue.text || clue.url)) {
                this.$set(clue, 'is_empty', false)
            }
        },
        isMerlinMedia(media) {
            return media.toLowerCase().includes('merlinone')
        },
    }
}
</script>
